import Vue from 'vue'
import Router from 'vue-router'
import * as Login from "@/modules/login";
import * as Home from "@/modules/home";
import * as CaviteEdit from "@/modules/cavite-edit";
import * as Admin from "@/modules/admin";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkExactActiveClass: 'is-active',
  base: (window as any).rootConfig.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home.Index,
      beforeEnter: async (to, from, next) => {
        await store.dispatch("loadLexiques");
        next();
      },
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'admin',
          name: 'admin.index',
          component: Admin.Index,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'edit/:id',
          name: 'cavite.edit',
          component: CaviteEdit.Index,
          redirect: { name: 'cavite.edit.description' },
          props: true,
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: 'description',
              name: 'cavite.edit.description',
              components: {
                mainTab: CaviteEdit.PartDescription
              },
            },
            {
              path: 'sourceInfos',
              name: 'cavite.edit.sourceInfos',
              components: {
                mainTab: CaviteEdit.PartSourcesInfos
              },
            },
            {
              path: 'descCompl',
              name: 'cavite.edit.descCompl',
              components: {
                mainTab: CaviteEdit.PartDescCompl
              },
            },
            {
              path: 'commentaire',
              name: 'cavite.edit.commentaire',
              components: {
                mainTab: CaviteEdit.PartCommentaire
              },
            },
            {
              path: 'poc',
              name: 'cavite.edit.poc',
              components: {
                mainTab: CaviteEdit.PartPoc
              },
            },
            {
              path: 'ddtm59',
              name: 'cavite.edit.ddtm59',
              components: {
                mainTab: CaviteEdit.PartDDTM59.Main
              },
            },
            {
              path: 'ems',
              name: 'cavite.edit.ems',
              components: {
                mainTab: CaviteEdit.PartEms.Main
              },
              redirect: { name: 'cavite.edit.ems.identification' },
              children: [
                {
                  path: 'identification',
                  name: 'cavite.edit.ems.identification',
                  components: {
                    mainEmsTab: CaviteEdit.PartEms.Identification
                  },
                },
                {
                  path: 'description-ouvrage',
                  name: 'cavite.edit.ems.descriptionOuvrage',
                  components: {
                    mainEmsTab: CaviteEdit.PartEms.DescriptionOuvrage
                  },
                },
                {
                  path: 'doc-plans',
                  name: 'cavite.edit.ems.docPlans',
                  components: {
                    mainEmsTab: CaviteEdit.PartEms.DocPlans
                  },
                },
                {
                  path: 'desordre-secu',
                  name: 'cavite.edit.ems.desordreSecu',
                  components: {
                    mainEmsTab: CaviteEdit.PartEms.DesordreSecu
                  },
                },
                {
                  path: 'actions',
                  name: 'cavite.edit.ems.actions',
                  components: {
                    mainEmsTab: CaviteEdit.PartEms.Actions
                  },
                },
                {
                  path: 'suivi-travaux',
                  name: 'cavite.edit.ems.suiviTravaux',
                  components: {
                    mainEmsTab: CaviteEdit.PartEms.SuiviTravaux
                  },
                },
                {
                  path: 'carto',
                  name: 'cavite.edit.ems.carto',
                  props: {mainEmsTab: true},
                  components: {
                    mainEmsTab: CaviteEdit.PartEms.Carto
                  },
                },
              ]
            }
          ]
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login.Index,
      meta: {
        requiresAuth: false
      }
    }
  ]
});

router.beforeEach((to, from, next) => {

  // User must be authenticated on every route
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!(store as any).state.login.isAuthenticated) {
      return next({ path: "/login" });
    }
  }

  return next();
});

export default router;
